import { all, call, fork, put, takeEvery } from 'redux-saga/effects';
import { clientQuery } from 'Core/data/GraphQLApi';
import { ExceptionManager } from 'Core/logManager';
import { endpoints } from 'Core/defaultValues';

import { RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_REQUEST } from 'Redux/actionTypes';
import { openVideoPlayerModal, refreshMitacVideoUrlsError } from 'Redux/actions';

function* refreshMitacVideoUrls({ payload }) {
    const { fleetId, snapshotId, title } = payload;
    try {
        let QUERY = `
            query getSnapshotStatus ($fleetId: String!, $snapshotId: String!) {
                result: getSnapshotStatus (fleetId: $fleetId, snapshotId: $snapshotId)
            }
        `;

        let data = yield call(clientQuery, QUERY, { fleetId, snapshotId }, endpoints.GRAPHQL_GENERAL);
        const snapshot = data?.result ? JSON.parse(data.result) : null;
        const media = Array.isArray(snapshot?.media) ? snapshot.media : [];
        const urls = media
            .slice()
            .sort((a, b) => Number(a?.channel) - Number(b?.channel))
            .map((m) => m?.presigned_url)
            .filter(Boolean);

        if (urls.length > 0) {
            yield put(openVideoPlayerModal({ urls, title }));
        } else {
            yield put(refreshMitacVideoUrlsError());
        }
    } catch (exc) {
        yield put(refreshMitacVideoUrlsError());
        ExceptionManager(exc, 'Modules/rawData/.components/videoPlayer/redux/saga', 'refreshMitacVideoUrls');
    }
}

function* watchVideoPlayerRequests() {
    yield takeEvery(RAW_DATA_VIDEO_PLAYER_REFRESH_URLS_REQUEST, refreshMitacVideoUrls);
}

export default function* rootSaga() {
    yield all([fork(watchVideoPlayerRequests)]);
}
